import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {MatIconType} from '../../types/icon.enum';

@Component({
  selector: ' greydom-icon-navigate',
  templateUrl: './icon-navigate.component.html',
  styleUrls: []
})
export class IconNavigateComponent {
  @Input() icon: MatIconType | string = MatIconType.ReviewIcon;
  @Input() route: string | any[];
  @Input() customTooltip?: string;
  @Input() queryParams?: { [key: string]: any };
  @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  constructor(private router: Router) {
  }

  onIconClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.onClick.emit(event);
    if (this.route) {
      this.router.navigate(Array.isArray(this.route) ? this.route : [this.route], {
        queryParams: this.queryParams
      });
    }
  }
}